module.exports = __webpack_public_path__ + "media/stop-1.294e1f08.mp3";